import { render } from "./table.vue?vue&type=template&id=c4f2c5de&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=c4f2c5de&lang=css"
import "./table.vue?vue&type=style&index=1&id=c4f2c5de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f2c5de"]])

export default __exports__